export enum ApiSpec {
  UPLOAD_MAX_FILESIZE = 40
}

export enum CustomHeader {
  CLIENT_URL = 'CE-Client-Url',
  ESTATE_ID = 'CE-Estate-ID',
  WITHOUT_USER_ESTATE_SCOPE = 'CE-Without-User-Estate-Scope'
}

export enum Route {
  ACCOUNTING_EXPORTACCOUNTS = 'accounting/export-accounts',
  ACCOUNTING_NEWEXPORTACCOUNTS = 'accounting/new-export-accounts',
  ACCRUED_INTERESTS = 'accrued-interests',
  ADMIN_FEATUREFLAGS = 'admin/feature-flags',
  ADMIN_MAILTEMPLATES = 'admin/mail-templates',
  ADMIN_PERMISSIONS = 'admin/permissions',
  AI_ADMINTOOL_PREDICT = 'ai/admin-tool/predict',
  AI_ADMINTOOL_FUZZYSEARCH = 'ai/admin-tool/fuzzy-search',
  AI_CLARA_ASKQUESTION = 'ai/clara/ask-question',
  AI_CLARA_STREAM_QUESTION = 'ai/clara/stream-question',
  AI_CLARA_CANCELQUESTION = 'ai/clara/cancel-question',
  AI_CLARA_CONVERSATIONS = 'ai/clara/conversations',
  AI_CLARA_MESSAGE_FEEDBACK = 'ai/clara/message/feedback',
  AI_CLARA_MESSAGE_ADDTOLIBRARY = 'ai/clara/message/add-to-library',
  AI_CLARA_CONVERSATION_FEEDBACK = 'ai/clara/conversation/feedback',
  AI_CLARA_CONVERSATION_PIN = 'ai/clara/conversation/pin',
  AI_CLARA_CONVERSATION_UPDATETITLE = 'ai/clara/conversation/update-title',
  AI_CLARA_SUPPORTTICKET = 'ai/clara/support-ticket',
  AI_DOCUMENT_ANALYZE = 'ai/document/analyze',
  AI_DOCUMENT_ANALYZE_BATCH = 'ai/document/analyze-batch',
  AI_DOCUMENT_BATCH_REVIEW = 'ai/document/batch-review',
  AI_DOCUMENT_BATCH_IMPORT = 'ai/document/batch-import',
  AI_DOCUMENT_STOP_ANALYSIS = 'ai/document/stop-analysis',
  AI_CONTENTSOURCE = 'ai/content-source',
  AI_CONTENTSOURCE_SAVEDRAFT = 'ai/content-source/save-draft',
  AI_CONTENTSOURCE_PUBLISH = 'ai/content-source/publish',
  AI_CONTENTSOURCE_UNPUBLISH = 'ai/content-source/unpublish',
  AI_CONTENTSOURCE_UPLOADFILE = 'ai/content-source/upload-file',
  AI_CONTENTSOURCE_DELETEFILE = 'ai/content-source/delete-file',
  AI_CONTENTSOURCE_URLDOMAINS = 'ai/content-source/url-domains',
  AI_CONTENTSOURCE_ADVISOR_BULKUPLOAD = 'ai/content-source/advisor/bulk-upload',
  AI_CONTENTSOURCE_ADVISOR_BULKUPLOAD_AND_PUBLISH = 'ai/content-source/advisor/bulk-upload-and-publish',
  AI_EXTRACT_BANKSTATEMENT = 'ai/extract/bank-statement',
  AI_EXTRACT_WILL = 'ai/extract/will',
  AI_EXTRACT_WILL_CREATEEXTRACTEDUSER = 'ai/extract/will/create-extracted-user',
  AI_EXTRACT_UPDATE_EXTRACTEDUSER = 'ai/extract/update/extracted-user',
  AI_EXTRACT_DELETE_EXTRACTEDUSER = 'ai/extract/delete/extracted-user',
  AI_EXTRACT_UPDATE_EXTRACTEDASSET = 'ai/extract/update/extracted-asset',
  AI_EXTRACT_DELETE_EXTRACTEDASSET = 'ai/extract/delete/extracted-asset',
  AI_EXTRACT_IMPORT_EXTRACTEDUSER = 'ai/extract/import/extracted-user',
  AI_EXTRACT_IMPORT_EXTRACTEDASSET = 'ai/extract/import/extracted-asset',
  AI_RAG_HASVIEWEDCLARA = 'ai/rag/has-viewed-clara',
  AI_RAG_HASVIEWEDFORPLANNERSLAUNCHER = 'ai/rag/has-viewed-for-planners-launcher',
  AI_RESEARCH_FETCHACTIVE = 'ai/research/fetch-active',
  AI_RESEARCH_GENERATEESTATECONTEXT = 'ai/research/generate-estate-context',
  AI_RESEARCH_PREDICTANSWER = 'ai/research/predict-answer',
  AI_VALIDATE_BANKSTATEMENT = 'ai/validate/bank-statement',
  AI_VALIDATE_WILL = 'ai/validate/will',
  AI_VALIDATE_STEP895621EXTRACTION = 'ai/validate/step895621-extraction',
  AI_RESEARCH = 'ai/research',
  AI_SUMMARY = 'ai/summary',
  AI_SUMMARY_CREATE = 'ai/summary/create',
  ANALYTICS = 'analytics',
  ANNOUNCEMENTS = 'announcements',
  ANNOUNCEMENTS_MARKASSEEN = 'announcements/mark-as-seen',
  ANNOUNCEMENTS_UPLOADIMAGE = 'announcements/upload-image',
  ASSETS = 'assets',
  ASSETS_PROBATABLE = 'assets/probatable-assets',
  ASSETS_LINK_FINANCIAL_TRANSACTIONS = 'assets/link-financial-transactions',
  ASSETS_NOTIFY_REAL_ESTATE_OWNED_IN_QUEBEC = 'assets/notify-real-estate-owned-in-quebec',
  AUDITS = 'audits',
  AUDITS_ITEMIZED = 'audits/itemized',
  AUTH = 'auth',
  AUTH_USER = 'auth/user',
  AUTH_AUTHENTICATEINVITATION = 'auth/authenticate-invitation',
  AUTH_CHANGEPASSWORD = 'auth/change-password',
  AUTH_CHECKRESETTOKEN = 'auth/check-reset-token',
  AUTH_COMPLETETRIAGE = 'auth/complete-triage',
  AUTH_COMPANYSSO = 'auth/company-sso',
  AUTH_CONFIRMINVITATION = 'auth/confirm-invitation',
  AUTH_IMPERSONATEUSER = 'auth/impersonate-user',
  AUTH_UNIMPERSONATEUSER = 'auth/unimpersonate-user',
  AUTH_LOGIN = 'auth/login',
  AUTH_LOGIN_GOOGLE = 'auth/login/google',
  AUTH_ADVISOR_LOGIN_SAML = 'auth/advisor/login/saml2',
  AUTH_LOGIN_SAML = 'auth/login/saml2',
  AUTH_LOGIN_OTP = 'auth/login/otp',
  AUTH_LOGIN_GET_OTP = 'auth/login/get-otp',
  AUTH_LOGIN_SEND_OTP = 'auth/login/send-otp',
  AUTH_LOGIN_GOOGLE_SELFSERVEPLAN = 'auth/login/google/self-serve-plan',
  AUTH_LOGIN_GOOGLE_AFTERCARE = 'auth/login/google/aftercare',
  AUTH_LOGIN_GOOGLE_VAULT = 'auth/login/google/vault',
  AUTH_LOGIN_FACEBOOK = 'auth/login/facebook',
  AUTH_OUTLOOK = 'auth/outlook',
  AUTH_OUTLOOK_REDIRECT = 'auth/outlook/redirect',
  OUTLOOK_BOOKED_TIMES = 'outlook/booked-times',
  AUTH_LOGOUT = 'auth/logout',
  AUTH_REGISTER = 'auth/register',
  AUTH_REGISTER_ADVISOR = 'auth/register/advisor',
  AUTH_REGISTER_AFTERCARE = 'auth/register/aftercare',
  AUTH_REGISTER_SETTLEMENT = 'auth/register/settlement',
  AUTH_REGISTER_SELFSERVEPLAN = 'auth/register/self-serve-plan',
  AUTH_REGISTER_VAULT = 'auth/register/vault',
  AUTH_REGISTER_PARTNER_SELF_SERVE_VAULT = 'auth/register/partner-self-serve-vault',
  AUTH_EMAIL_RESEND = 'auth/email/resend',
  AUTH_RESETPASSWORD = 'auth/reset-password',
  AUTH_SENDRESETPASSWORDLINK = 'auth/send-reset-password-link',
  AUTH_SESSION = 'auth/session',
  AUTH_REFRESHAUTHUSERTOKEN = 'auth/refresh-auth-user-token',
  BILLINGS_ADVISOR_ACTIVE_PLAN = 'billings/advisor/active-plan',
  BILLINGS_ADVISOR_CANCEL_PLAN = 'billings/advisor/cancel-plan',
  BILLINGS_ADVISOR_NEXT_PLAN = 'billings/advisor/next-plan',
  BILLINGS_ADVISOR_CHANGEPLAN = 'billings/advisor/change-plan',
  BILLINGS_ADVISOR_CREATECHECKOUTSESSION = 'billings/advisor/create-checkout-session',
  BILLINGS_ADVISOR_PAYMENTMETHOD = 'billings/advisor/payment-method',
  BILLINGS_ADVISOR_CREATEPAYMENTMETHODPORTALSESSION = 'billings/advisor/create-payment-method-portal-session',
  BILLINGS_ADVISOR_SETSUBSCRIPTIONDEFAULTPAYMENTMETHOD = 'billings/advisor/set-subscription-default-payment-method',
  BILLINGS_ADVISOR_INVOICES = 'billings/advisor/invoices',
  BILLINGS_ADVISOR_UNCANCELPLAN = 'billings/advisor/uncancel-plan',
  BILLINGS_CREATEBILLINGPORTALSESSION = 'billings/create-billing-portal-session',
  BILLINGS_CREATECHECKOUTSESSION = 'billings/create-checkout-session',
  BILLINGS_PLANS = 'billings/plans',
  BILLINGS_ADDONS = 'billings/addons',
  BILLINGS_COUPONS = 'billings/coupons',
  BILLINGS_DOWNLOADINVOICE = 'billings/download-invoice',
  BILLINGS_USER_PLAN = 'billings/user/plan',
  BILLINGS_USER_SUBSCRIPTION = 'billings/user/subscription',
  BILLINGS_USER_INVOICES = 'billings/user/invoices',
  BILLINGS_USER_ADDONS = 'billings/user/addons',
  BILLINGS_CALCULATEBILLINGPLANPRICES = 'billings/calculate-billing-plan-prices',
  BILLINGS_USER_COUPONS = 'billings/user/coupons',
  BILLINGS_USER_PAYMENTSOURCES = 'billings/user/payment-sources',
  BILLINGS_USER_CUSTOMER = 'billings/user/customer',
  BILLINGS_USER_POSTCHECKOUT = 'billings/user/post-checkout',
  BILLINGS_USER_CHECKOUT_URL = 'billings/user/checkout-url',
  BILLINGS_USER_CHECKOUTEXISTINGURL = 'billings/user/checkout-existing-url',
  BILLINGS_USER_REMOVEPAYMENTMETHOD = 'billings/user/remove-payment-method',
  BOOKINGLINKS_EXTERNAL_SHOW = 'booking-links',
  BOOKINGLINKS_GENERATE = 'booking-links/generate',
  BOOKINGLINKS_SENDINVITATION = 'booking-links/send-invitation',
  BROADCASTING_AUTH = 'broadcasting/auth',
  CALENDARMEETINGLINK = 'calendar-meeting-links',
  CALENDARMEETINGLINK_BOOKED = 'calendar-meeting-links/booked',
  CALENDARMEETINGLINK_BOOKEDNOTARIZATIONMEETING = 'calendar-meeting-links/booked-notarization-meeting',
  CALENDARMEETINGLINK_BOOKEDSTANDARDPLANNOTARIZATIONMEETING = 'calendar-meeting-links/booked-standard-plan-notarization-meeting',
  CHECKPOINTS = 'checkpoints',
  CHECKOUT_ALLOWPAYMENTINTENTFUTUREUSAGEOFFSESSION = 'checkout/allow-payment-intent-future-usage-off-session',
  CHECKOUT_EXPIREDLINK = 'checkout/expired-link',
  CHECKOUT_INIT = 'checkout/init',
  CHECKOUT_CREATEESTATE = 'checkout/create-estate',
  CHECKOUT_UPDATEDEALPROPERTIESONHUBSPOT = 'checkout/update-deal-properties-on-hubspot',
  COMPANIES = 'companies',
  COMPANY_SERVICES = 'company-services',
  CONTACTS_CO_OWNERS = 'contacts/co-owners',
  CONTACTS_CO_RESPONSIBLES = 'contacts/co-responsibles',
  CONVERSATIONS = 'conversations',
  CONVERSATIONS_ADDUSER = 'conversations/add-user',
  CONVERSATIONS_MARKREAD = 'conversations/mark-read',
  CONVERSATIONS_ARCHIVE = 'conversations/archive',
  CONVERSATIONS_SETGENERAL = 'conversations/set-general',
  COURTHOUSES_NOTIFYCOURTHOUSE = 'courthouses/notify-courthouse',
  CREDITORCLAIMS = 'creditor-claims',
  CYPRESS_CACHE_CLEAR = 'cypress/cache/clear',
  CYPRESS_SEED = 'cypress/seed',
  CYPRESS_LOGIN = 'cypress/login',
  DEV_MAILS_TEMPLATECONTENTS = 'dev/mails/templatecontents',
  DISCLAIMER_VAULT_PLAN = 'disclaimer/vault-plan',
  DISCLAIMER_WILL_REVIEW = 'disclaimer/will-review',
  DOCUMENTS = 'documents',
  DOCUMENTS_UPLOAD = 'documents/upload',
  DOCUMENTS_UPLOAD_NOTIFYESTATEPROFESSIONAL = 'documents/upload/notify-estate-professional',
  DOCUMENTS_DOWNLOAD = 'documents/download',
  DOCUMENTS_DOWNLOAD_ALL = 'documents/download/all',
  DOCUMENTS_NLP_PARSEDRIVERSLICENSE = 'documents/nlp/parse-drivers-license',
  DOCUMENTS_DOCUMENT_TYPES = 'documents/document-types',
  DOCUMENTS_DOCUMENT_SUB_TYPES = 'documents/document-sub-types',
  DOCUMENTS_SENDPARTNERUPLOADEDDOCUMENTNOTIFICATION = 'documents/send-partner-uploaded-document-notification',
  DOCUMENTS_MARK_READ_BY_ID = 'documents/{document}/mark-read',
  DOCUMENTS_UNREAD_COUNT = 'documents/unread-count',
  DOCUMENTS_SHARE = 'documents/share',
  DOCUMENTS_BULK_MOVE = 'documents/bulk-move',
  DOCUMENTS_SEARCH = 'documents/search',
  DOCUMENTS_PROBATE_META = 'documents/probate-meta',
  DOCUMENTS_GENERATELETTEROFFINALWISHES = 'documents/generate-letter-of-final-wishes',
  EDITOR_TEMPLATE = 'editor/templates',
  EDITOR_LAYOUTS = 'editor/layouts',
  EDITOR_TEMPLATE_CLAUSES = 'editor/template-clauses',
  EDITOR_TEMPLATE_CLAUSE_TOPICS = 'editor/template-clause-topics',
  EDITOR_TEMPLATE_CLAUSE_ALIASES = 'editor/template-clause-aliases',
  EDITOR_TEMPLATE_CLAUSE_ALIASES_GENERATE = 'editor/template-clauses/aliases/generate',
  EDITOR_TEMPLATE_CLAUSE_INSERTIONS = 'editor/templates/clause-insertions',
  EDITOR_TEMPLATE_CLAUSE_VERSIONS = 'editor/template-clause-versions',
  EDITOR_TEMPLATES_DOCUMENT = 'editor/templates/document',
  EDITOR_TEMPLATES_DOCUMENTS = 'editor/templates/documents',
  EDITOR_TEMPLATES_DOCUMENTS_DRAFTS = 'editor/templates/documents/drafts',
  EDITOR_TEMPLATES_DOCUMENT_DELETE = 'editor/templates/document/delete',
  EDITOR_TEMPLATES_DOCUMENT_REVERTAPPROVAL = 'editor/templates/document/revert-approval',
  EDITOR_TEMPLATES_DOCUMENT_SENDAPPROVEDEMAILTOPLANNER = 'editor/templates/document/send-approved-email-to-planner',
  EDITOR_TEMPLATE_APPROVE = 'editor/templates/approve',
  EDITOR_TEMPLATE_REQUEST_CHANGES = 'editor/templates/request-changes',
  EDITOR_TEMPLATE_SAVE = 'editor/templates/save',
  EDITOR_TEMPLATE_INJECT = 'editor/templates/inject',
  EDITOR_TEMPLATE_CONTENTS = 'editor/templates/contents',
  EDITOR_TEMPLATE_FOOTERCONTENTS = 'editor/templates/footer-contents',
  EDITOR_TEMPLATE_METADATA = 'editor/templates/meta-data',
  EDITOR_TEMPLATE_REGENERATE = 'editor/templates/regenerate',
  EDITOR_TEMPLATE_UPDATE = 'editor/templates/update',
  EDITOR_TEMPLATE_PDF = 'editor/templates/pdf',
  EDITOR_TEMPLATE_DOCUMENT_PDF = 'editor/templates/document/pdf',
  EDITOR_TEMPLATE_DOCUMENT_DOCX = 'editor/templates/document/docx',
  EDITOR_TEMPLATE_UPDATEOWNERUSER = 'editor/templates/update-owner-user',
  EDITOR_TEMPLATES_SENDEDITORTEMPLATEDOCUMENTFORPLANNERREVIEW = 'editor/templates/send-editor-template-document-for-planner-review',
  EDITOR_TEMPLATES_SENDDOCXDOCUMENTFORPLANNERREVIEW = 'editor/templates/send-docx-document-for-planner-review',
  EDITOR_TEMPLATES_DOCUMENT_SHAREPARTNEREDITORTEMPLATEDOCUMENT = 'editor/templates/document/share-partner-editor-template-document',
  EDITOR_FETCHTOKEN = 'editor/fetch-token',
  EMBEDURLS = 'embed-urls',
  EMBEDURLS_URLS = 'embed-urls/urls',
  ESIGN_ENVELOPES = 'esign/envelopes',
  ESIGN_ENVELOPES_CREATEALLOWANCEORREJECTTIONCREDITORCLAIM = 'esign/envelopes/create-allowance-or-rejection-creditor-claim',
  ESIGN_ENVELOPES_CREATETAXENVELOPE_TAXFORMDOCUMENT = 'esign/envelopes/create-tax-envelope/tax-form-document',
  ESIGN_ENVELOPES_CREATEDISTRIBUTIONPLANENVELOPE = 'esign/envelopes/create-distribution-plan-envelope',
  ESIGN_ENVELOPES_CREATEPROBATEENVELOPE = 'esign/envelopes/create-probate-envelope',
  ESIGN_ENVELOPES_CREATEGENERICPROBATEENVELOPE = 'esign/envelopes/create-generic-probate-envelope',
  ESIGN_ENVELOPES_CREATEINTERIMDISTRIBUTIONRELEASEENVELOPE = 'esign/envelopes/create-interim-distribution-release-envelope',
  ESIGN_ENVELOPES_CREATENOTIFYBENEFICIARIESENVELOPE = 'esign/envelopes/create-notify-beneficiaries-envelope',
  ESIGN_ENVELOPES_CREATELIMITEDSCOPEREPRESENTATIONAGREEMENTENVELOPE = 'esign/envelopes/create-limited-scope-representation-agreement-envelope',
  ESIGN_ENVELOPES_VOID = 'esign/envelopes/void',
  ESIGN_ENVELOPES_MARK_READ = 'esign/envelopes/mark-read',
  ENUMS = 'enums',
  ESTATEACCOUNTINGQUEBECDISTRIBUTIONS = 'estate-accounting-quebec-distributions',
  ESTATEACCOUNTINGQUEBECDISTRIBUTIONS_CALCULATE_ASSETVALUE = 'estate-accounting-quebec-distributions/calculate/asset-value',
  ESTATEACCOUNTINGQUEBECDISTRIBUTIONS_CALCULATE_ASSETVALUEBYCATEGORY = 'estate-accounting-quebec-distributions/calculate/asset-value-by-category',
  ESTATEACCOUNTINGQUEBECDISTRIBUTIONS_CALCULATE_REGIMEBALANCEAMOUNT = 'estate-accounting-quebec-distributions/calculate/regime-balance-amount',
  ESTATEACCOUNTINGQUEBECDISTRIBUTIONS_CALCULATE_LIABILITYVALUE = 'estate-accounting-quebec-distributions/calculate/liability-value',
  ESTATEACCOUNTINGQUEBECDISTRIBUTIONS_CALCULATE_LIABILITYVALUEBYCATEGORY = 'estate-accounting-quebec-distributions/calculate/liability-value-by-category',
  ESTATEACCOUNTINGQUEBECDISTRIBUTIONS_CONFIRMVALUES = 'estate-accounting-quebec-distributions/confirm-values',
  ESTATEACCOUNTINGQUEBECDISTRIBUTIONS_EXPORTINVENTORY = 'estate-accounting-quebec-distributions/export-inventory',
  ESTATE_TAX_FORMS = 'estate-tax-forms',
  ESTATE_TAX_FILINGS = 'estate-tax-filings',
  ESTATE_TASKS = 'estate-tasks',
  ESTATE_SNAPSHOT = 'estate/snapshot',
  ESTATEHEALTHCHECKS_GETFORM = 'estate-health-checks/get-form',
  ESTATEHEALTHCHECKS_SAVEFORM = 'estate-health-checks/save-form',
  ESTATEHEALTHCHECKS_PARTNERAPPROVE = 'estate-health-checks/partner-approve',
  ESTATEHEALTHCHECKS_PARTNERRESET = 'estate-health-checks/partner-reset',
  ESTATETASKS_USER = 'estate-tasks/user',
  ESTATES_MOVE_TO_TEAM = 'estates/move-to-team',
  ESTATE_TASKS_LAWYER_CONSULTATIONCENTERTASKS = 'estate-tasks/lawyer/consultation-center-tasks',
  ESTATETASKS_ASSIGNABLEBYGROUP = 'estate-tasks/assignable-by-group',
  ESTATES = 'estates',
  ESTATES_DEMOTEMPLATES = 'estates/demo-templates',
  ESTATES_ACCOUNTINGDETAILS = 'estates/accounting-details',
  ESTATES_ACCESSIBLEESTATES = 'estates/accessible-estates',
  ESTATES_ACCESSIBLEESTATES_ESTATESELECTION = 'estates/accessible-estates/estate-selection',
  ESTATES_ALLESTATES = 'estates/all-estates',
  ESTATES_ASSET_AVERAGES = 'estates/asset-averages',
  ESTATES_ASSIGNCASEMANAGER = 'estates/assign-case-manager',
  ESTATES_ASSIGNCONSULTANT = 'estates/assign-consultant',
  ESTATES_ASSIGNESTATECOORDINATOR = 'estates/assign-estate-coordinator',
  ESTATES_CLEAR_ESTATE = 'estates/clear-estate',
  ESTATES_CLOSE_ESTATE = 'estates/close-estate',
  ESTATES_COMPANIES_ALLESTATES = 'estates/companies/all-estates',
  ESTATES_COMPANIES_ACTIVEFILES = 'estates/companies/active-files',
  ESTATES_COMPANIES_ACTIVEFILES_FINANCIALADVISOR = 'estates/companies/active-files/financial-advisor',
  ESTATES_COMPANIES_ALLESTATES_NOTARY = 'estates/companies/all-estates/notary',
  ESTATES_COMPANIES_ALLESTATES_PARALEGAL = 'estates/companies/all-estates/paralegal',
  ESTATES_COMPANIES_ALLESTATES_PARTNERACCOUNTANT = 'estates/companies/all-estates/partner-accountant',
  ESTATES_COMPANIES_ALLESTATES_LAWYER = 'estates/companies/all-estates/lawyer',
  ESTATES_COMPANIES_ALLESTATES_TRUSTMANAGER = 'estates/companies/all-estates/trust-manager',
  ESTATES_COMPANIES_ALLESTATES_TRUSTOFFICER = 'estates/companies/all-estates/trust-officer',
  ESTATES_CREATEFROMHUBSPOT = 'estates/create-from-hubspot',
  ESTATES_CURRENTMARRIAGE = 'estates/current-marriage',
  ESTATES_GENERATE_CALIFORNIA_PETITION_FORMS = 'estates/california-petition-forms',
  ESTATES_HUBSPOTDEALCONTACTS = 'estates/hubspot-deal-contacts',
  ESTATES_ANNUAL_REVIEWS = 'estates/{estateId}/annual-reviews',
  ESTATES_LATEST_WILL_APPROVED_ESTATE_TASK_AUDIT = 'estates/{estateId}/latest-will-approved-estate-task-audit',
  ESTATES_DISTRIBUTION_FRAMEWORK_STAGE_COMPLETED_AUDIT_TIME = 'estates/{estateId}/distribution-framework-stage-completed-audit-time',
  ESTATES_ESTATE_ASSETS = 'estates/{estateId}/assets',
  ESTATES_ESTATE_FAMILY_TREE_GENERATE = 'estates/{estateId}/family-tree/generate',
  ESTATES_FAMILY_TREE_NODE_POSITIONS = 'estates/family-tree/node-positions',
  ESTATES_FAMILY_TREE_CONTACTS = 'estates/family-tree/contacts',
  ESTATES_ESTATE_LIABILITIES = 'estates/{estateId}/liabilities',
  ESTATES_LIQUIDATIONPROGRESS = 'estates/liquidation-progress',
  ESTATES_MARKINVENTORYASUPTODATE = 'estates/mark-inventory-as-up-to-date',
  ESTATES_ONBOARDING = 'estates/onboarding',
  ESTATES_ONBOARDING_AFTERCARE = 'estates/onboarding/aftercare',
  ESTATES_ONBOARDING_PARTNERSELFSERVEPLAN = 'estates/onboarding/partner-self-serve-plan',
  ESTATES_ONBOARDING_SELFSERVEPLAN = 'estates/onboarding/self-serve-plan',
  ESTATES_ONBOARDING_VAULT = 'estates/onboarding/vault',
  ESTATES_ONBOARDING_STANDARD_PLAN_OVERVIEW = 'estates/onboarding/standard-plan/overview',
  ESTATES_ONBOARDING_GET_REFERRAL = 'estates/onboarding/get-referral',
  ESTATES_QUEBECMATRIMONIALREGIME = 'estates/quebec-matrimonial-regime',
  ESTATES_SET_ESTATE = 'estates/set-estate',
  ESTATES_SETCOMPLETEBYLAWYER = 'estates/set-complete-by-lawyer',
  ESTATES_STAGEDATA_PLANNING = 'estates/stage-data/planning',
  ESTATES_TRANSITION_ESTATE = 'estates/transition-estate',
  ESTATES_TRANSITION_CLEARVAULT = 'estates/transition/clear-vault',
  ESTATES_TOGGLEWILLINPUTSTAGESLOCKED = 'estates/toggle-will-input-stages-locked',
  ESTATES_UPDATE_LAWYER_STATUS = 'estates/update-lawyer-status',
  ESTATES_UPDATE_NOTARY_STATUS = 'estates/update-notary-status',
  ESTATES_UPDATE_STATUS = 'estates/update-status',
  ESTATES_VAULTS = 'estates/vaults',
  ESTATES_VAULTS_COUPLES = 'estates/vaults/couples',
  ESTATES_VAULTS_COUPLESINVITEPARTNER = 'estates/vaults/couples-invite-partner',
  ESTATES_VAULTS_COUPLESINVITESELFSERVEPARTNER = 'estates/vaults/couples-invite-self-serve-partner',
  COUPLES_SPACE_AVAILABLE = 'couples-space/available',
  COUPLES_SPACE_IMPORT = 'couples-space/import',
  COUPLES_SPACE_DISMISS = 'couples-space/dismiss',
  COUPLES_SPACE_SET_PRIMARY = 'couples-space/set-primary',
  COUPLES_SPACE_SYNCED = 'couples-space/synced',
  COUPLES_SPACE_SENT = 'couples-space/sent',
  ESTATES_VAULTS_FETCHSELFSERVEPARTNERDEAL = 'estates/vaults/fetch-self-serve-partner-deal',
  ESTATES_VAULTS_FETCHPARTNERESTATE = 'estates/vaults/fetch-partner-estate',
  ESTATES_VAULTS_SAVEREFERRALPARTNER_PAIDPLAN = 'estates/vaults/save-referral-partner-paid-plan',
  ESTATEFORMTEMPLATES = 'estate-form-templates',
  ESTATEFORMTEMPLATES_GENERATE = 'estate-form-templates/generate',
  ESTATEFORMTEMPLATES_NOTIFYSTATUSCHANGE = 'estate-form-templates/notify-status-change',
  ESTATEFORMTEMPLATES_BULKSENDFORREVIEW = 'estate-form-templates/bulk-send-for-review',
  ESTATEFORMTEMPLATES_SENDFORREVIEW = 'estate-form-templates/send-for-review',
  ESTATEFORMTEMPLATES_APPROVE = 'estate-form-templates/approve',
  ESTATEFORMTEMPLATES_CREATEESTATEFORMTEMPLATEDOCUMENTASPDF = 'estate-form-templates/create-estate-form-template-document-as-pdf',
  ESTATEACCOUNTS = 'estate-accounts',
  ESTATEACCOUNTS_ACCOUNTANTS_COMPLETE = 'estate-accounts/accountants/complete',
  ESTATEACCOUNTS_ALL = 'estate-accounts/all',
  ESTATEACCOUNTS_ALL_INBOX = 'estate-accounts/all/inbox',
  ESTATEACCOUNTS_BENEFICIARIES = 'estate-accounts/beneficiaries',
  ESTATEACCOUNTS_ESTATEADMINS_SETPRIMARY = 'estate-accounts/estate-admins/set-primary',
  ESTATEACCOUNTS_ESTATEMEMBERS = 'estate-accounts/estate-members',
  ESTATEACCOUNTS_EXECUTORS = 'estate-accounts/executors',
  ESTATEACCOUNTS_PROFESSIONALS = 'estate-accounts/professionals',
  ESTATEACCOUNTS_SPECIFICBENEFICIARYACCOUNTINGDETAIL = 'estate-accounts/specific-beneficiary-accounting-detail',
  ESTATEACCOUNTS_SPECIFICBENEFICIARIESFORESTATE = 'estate-accounts/specific-beneficiaries-for-estate',
  ESTATEBANKINGREQUESTS = 'estate-banking-requests',
  ESTATEBANKINGREQUESTS_DOCUMENTS = 'estate-banking-requests/documents',
  ESTATEBANKINGREQUESTSUSERS = 'estate-banking-requests-users',
  ESTATEBANKINGREQUESTS_ALLREQUESTS = 'estate-banking-requests/all-requests',
  ESTATEBANKINGREQUESTS_SINCELASTLOGIN = 'estate-banking-requests/since-last-login',
  ESTATEBANKINGREQUESTS_DOWNLOADDOCUMENTS = 'estate-banking-requests/download-documents',
  ESTATEDISTRIBUTIONS = 'estate-distributions',
  ESTATEDISTRIBUTIONS_REMINDER = 'estate-distributions/reminder',
  ESTATEDISTRIBUTIONS_SAVEDISTRIBUTIONS = 'estate-distributions/save-distributions',
  ESTATEDISTRIBUTIONS_TREE = 'estate-distributions/tree',
  ESTATEDISTRIBUTIONS_TREE_FLATTEN = 'estate-distributions/tree/flatten',
  ESTATEDISTRIBUTIONS_TREE_NODES = 'estate-distributions/tree/nodes',
  ESTATEDISTRIBUTIONS_CREATEPAYMNETFORBENEFICIARY = 'estate-distributions/create-payment-for-beneficiary',
  ESTATEDISTRIBUTIONPLAN_NOTIFYDISAGREEMENT = 'estate-distribution-plan/notify-disagreement',
  ESTATEINTERIMDISTRIBUTIONRELEASE_REMINDER = 'estate-interim-distribution-release/reminder',
  ESTATEINTERIMDISTRIBUTION_LOCKINTERIMDISTRIBUTION = 'estate-interim-distribution/lock-interim-distribution',
  ESTATEINSTITUTIONS_GENERATELETTER = 'estate-institutions/generate-letter',
  ESTATEINSTITUTIONS_GENERATEDIRECTTIONANDAUTHORIZATION = 'estate-institutions/generate-directions-and-authorization',
  ESTATEPRODUCTS = 'estate-products',
  ESTATEPRODUCTS_ADD = 'estate-products/add',
  ESTATEPRODUCTS_CANCELSUBSCRIPTION = 'estate-products/cancel-subscription',
  ESTATEPRODUCTS_UNCANCELSUBSCRIPTION = 'estate-products/un-cancel-subscription',
  ESTATECONSENTS = 'estate-consents',
  ESTATECONSENTS_PARTNER = 'estate-consents/partner',
  ESTATEFORMS = 'estate-forms',
  ESTATENOMINATIONS = 'estate-nominations',
  ESTATEUPSELLS = 'estate-upsells',
  ESTATEUPSELLS_CLEARWILL_GUIDANCEPROGRESS = 'estate-upsells/clear-will/guidance-progress',
  ESTATEUPSELLS_CLEARESTATE_ADDONNOTIFICATION = 'estate-upsells/clear-estate/add-on-notification',
  ESTATEUPSELLS_CLEARESTATE_CALLREQUESTNOTIFICATION = 'estate-upsells/clear-estate/call-request-notification',
  ESTATEUPSELLS_CLEARVAULT_ESTATEPROFESSIONALCALLREQUESTNOTIFICATION = 'estate-upsells/clear-vault/estate-professional-call-request-notification',
  EXPORT_DATA = 'export/data',
  EXPORT_PDF = 'export/pdf',
  EXPORT_PDF_TEMPLATE = 'export/pdf/template',
  FEATURE_INTERESTS = 'feature-interests',
  MEMOIR_LETTERS = 'memoir/letters',
  FEEDBACK = 'feedback',
  FINANCIAL_ACCOUNTS = 'financial-accounts',
  FINANCIAL_ACCOUNTS_REMINDER = '/financial-accounts/reminder',
  FINANCIAL_ACCOUNTS_SUBTYPES_BANKACCOUNT = 'financial-accounts/sub-types/bank-account',
  FINANCIAL_ACCOUNT_TRANSACTIONS = 'financial-account-transactions',
  FINANCIAL_ACCOUNT_TRANSACTIONS_SPLIT_TRANSACTION = 'financial-account-transactions/split-transaction',
  FINANCIAL_ACCOUNT_TRANSACTIONS_SINCELASTLOGIN = 'financial-account-transactions/since-last-login',
  FINANCIAL_ACCOUNT_TRANSACTIONS_REVERT = 'financial-account-transactions/revert',
  FINANCIAL_ACCOUNTS_UNLINK = 'financial-accounts/unlink-accounts',
  FINANCIAL_ACCOUNTS_UPDATE_MANUAL_CASHFLOW = 'financial-accounts/update-manual-cashflow',
  FINANCIAL_ACCOUNTS_SAVE_ACCOUNTS = 'financial-accounts/save-accounts',
  FINANCIAL_ACCOUNTS_CONNECTED_INSTITUTIONS = 'financial-accounts/connected-institutions',
  FINANCIAL_ACCOUNTS_ESTATEBANKACCOUNT = 'financial-accounts/estate-bank-account',
  FINANCIAL_ACCOUNTS_REQUESTESTATEBANKACCOUNT = 'financial-accounts/request-estate-bank-account',
  FINANCIAL_ACCOUNTS_UPDATE_BALANCES = 'financial-accounts/update-balances',
  FINANCIAL_ACCOUNTS_UPDATE_BALANCE = 'financial-accounts/update-balance',
  FINANCIAL_ACCOUNTS_CONNECTED = 'financial-accounts/connected',
  FINANCIAL_GATEWAY = 'financial-gateway',
  FINANCIAL_GATEWAY_CREATE_LINK = 'financial-gateway/create-link',
  FINANCIAL_GATEWAY_CREATE_TOKEN = 'financial-gateway/create-token',
  FINANCIAL_GATEWAY_UPDATE_LINK = 'financial-gateway/update-link',
  FINANCIAL_GATEWAY_UPDATE_TOKEN = 'financial-gateway/update-token',
  FINANCIAL_GATEWAY_EXCHANGE_LINK = 'financial-gateway/exchange-link',
  FINANCIAL_GATEWAY_DOWNLOAD_ACCOUNTS = 'financial-gateway/download-accounts',
  FINANCIAL_GATEWAY_DOWNLOAD_TRANSACTIONS = 'financial-gateway/download-transactions',
  GUIDANCESTEPS = 'guidance-steps',
  GUIDANCESTEPS_STAGES = 'guidance-steps/stages',
  GUIDANCESTEPS_CURRENTSTEP = 'guidance-steps/current-step',
  GUIDANCESTEPS_SEND_CHECKLIST = 'guidance-steps/send-checklist',
  GUIDANCESTEPS_STEPFROMTOKEN = 'guidance-steps/step-from-token',
  GUIDANCESTEPS_SETFIRSTACCESSEDAT = 'guidance-steps/set-first-accessed-at',
  GUIDANCESTEPS_STEPFORM = 'guidance-steps/step-form',
  GUIDANCESTEPS_NEXTSTEP = 'guidance-steps/next-step',
  GUIDANCESTEPS_PREVIOUSSTEP = 'guidance-steps/previous-step',
  GUIDANCESTEPS_STEPNAME = 'guidance-steps/step-name',
  GUIDANCESTEPS_INITIATE_JOB_ON_STEP_START = 'guidance-steps/initiate-job-on-step-start',
  GUIDANCESTEPGROUPWIDGETS = 'guidance-step-group-widgets',
  GUIDANCESTEPGROUPWIDGETS_UPDATEPROGRESS = 'guidance-step-group-widgets/update-progress',
  HUBSPOTMEETINGLINKS = 'hubspot-meeting-links',
  HUBSPOTMEETINGLINKS_BOOKEDEXECUTORKICKOFFMEETING = 'hubspot-meeting-links/booked-executor-kickoff-meeting',
  INBOX_DEFAULTCONVERSATION = 'inbox/default-conversation',
  INBOX_CONVERSATIONS = 'inbox/conversations',
  INBOX_EXISTINGCONVERSATION = 'inbox/existing-conversation',
  INBOX_UNREADCONVERSATIONS = 'inbox/unread-conversations',
  INBOX_GROUPCONVERSATION = 'inbox/group-conversation',
  INBOX_SENDBOTMESSAGE = 'inbox/send-bot-message',
  INBOX_CLARADRAFTS_SEND = 'inbox/clara-drafts/send',
  INBOX_CLARADRAFTS_DISCARD = 'inbox/clara-drafts/discard',
  JOBS_ASYNSREQUESTRESPONSE = 'jobs/async-request-response',
  LIABILITIES = 'liabilities',
  LIABILITIES_EXECUTOR_COMPENSATIONS = 'liabilities/executor-compensations',
  LIABILITIES_LINK_FINANCIAL_TRANSACTIONS = 'liabilities/link-financial-transactions',
  LIABILITIES_LINK_PROOF_OF_PAYMENT = 'liabilities/link-proof-of-payment',
  LIABILITIES_PROBATABLE = 'liabilities/probatable-liabilities',
  LIGHTDIAGNOSTIC_CALCULATEBILLINGPLAN = 'light-diagnostic/calculate-billing-plan',
  LIGHTDIAGNOSTIC_SYNCSUBMISSIONTOHUBSPOT = 'light-diagnostic/sync-submission-to-hubspot',
  LIGHTDIAGNOSTICSUBMISSIONS = 'light-diagnostic-submissions',
  LOCALIZATION_CONTENT = 'localization/content',
  LOCALIZATION_BACKEND_LIST = 'localization/backend-list',
  LOCALIZATION_FRONTEND_LIST = 'localization/frontend-list',
  MEETINGS = 'meetings',
  MEETINGS_AVAILABILITIES = 'meetings/availabilities',
  MEETINGS_DASHBOARD = 'meetings/dashboard',
  MEETINGS_INVITEES = 'meetings/invitees',
  MEETINGS_STARTED_AT = 'meetings/started_at',
  MEETINGS_EVENT_TYPES = 'meetings/event-types',
  MEETINGS_JOIN_URL = 'meetings/join-url',
  MEETINGS_BOOKNEW = 'meetings/book-new',
  MEETINGS_BOOK = 'meetings/book',
  MEETINGS_CANCEL = 'meetings/cancel',
  MEETINGS_CREATEEVENTINVITEE = 'meetings/create-event-invitee',
  MEETINGS_RESCHEDULE = 'meetings/reschedule',
  MEETINGS_REFERRALCONSULT = 'meetings/referral-consult',
  MEETINGS_SKIP = 'meetings/skip',
  MEETINGUSERS = 'meeting-users',
  MEMOIR_PROMPT_LIBRARY = 'memoir/prompt-library',
  MESSAGES = 'messages',
  MESSAGES_MARKREAD = 'messages/mark-read',
  METRICS_UPDATE_ESTATE = 'metrics/update/estate',
  METRICS_UPDATE_ESTATEACCOUNT = 'metrics/update/estate-account',
  METRICS_UPDATE_USER = 'metrics/update/user',
  NOTES = 'notes',
  NOTES_ESTATE_USERS = 'notes/estate/users',
  NOTIFICATIONHISTORIES = 'notification-histories',
  OCR_READFILE = 'ocr/read-file',
  OPPORTUNITIES = 'opportunities',
  OPPORTUNITIES_MARK_AS_REVIEWED = 'opportunities/mark-as-reviewed',
  OPPORTUNITIES_UNDO_REVIEW = 'opportunities/undo-review',
  OPPORTUNITIES_SCANS = 'opportunities/scans',
  OPPORTUNITIES_SCAN = 'opportunities/scan',
  OPPORTUNITIES_SCAN_USER_ESTATES = 'opportunities/scan-user-estates',
  OTP_SENDVERIFICATION = 'otp/send-verification',
  OTP_VERIFYTOKEN = 'otp/verify-token',
  PARTNERSHIPINVITATIONS = 'partnership-invitations',
  PARTNERSHIPINVITATIONS_PENDING = 'partnership-invitations/pending',
  PARTNERSHIPINVITATIONS_RESEND = 'partnership-invitations/resend',
  PARTNERSHIPINVITATIONS_INVITECLIENT = 'partnership-invitations/invite-client',
  PLATFORMREFERRALS = 'platform-referrals',
  PLATFORMREFERRALS_IDENTIFY = 'platform-referrals/identify',
  POWEROFATTORNEY_PERSONALCARES = 'power-of-attorney/personal-cares',
  POWEROFATTORNEY_PROPERTIES = 'power-of-attorney/properties',
  POWEROFATTORNEY_FINALIZEANDSENDTOPLANNER = 'power-of-attorney/finalize-and-send-to-planner',
  POWEROFATTORNEY_GENERATEFINALPROPERTYDOCUMENT = 'power-of-attorney/generate-final-property-document',
  POWEROFATTORNEY_HEALTHCAREDIRECTIVEDOCUMENT = 'power-of-attorney/healthcare-directive-document',
  POWEROFATTORNEY_PERSONALCAREDOCUMENT = 'power-of-attorney/personal-care-document',
  POWEROFATTORNEY_PROPERTYDOCUMENT = 'power-of-attorney/property-document',
  POWEROFATTORNEY_PROPERTYANDPERSONALCAREDOCUMENT = 'power-of-attorney/property-and-personal-care-document',
  POWEROFATTORNEY_RESET = 'power-of-attorney/reset',
  POWEROFATTORNEY_SENDTOPARTNER = 'power-of-attorney/send-to-partner',
  POWEROFATTORNEY_UNSENDTOPARTNER = 'power-of-attorney/un-send-to-partner',
  PREDEFINED_COUNTIES = 'predefined/counties',
  PREDEFINED_COUNTRIES = 'predefined/countries',
  PREDEFINED_CRYPTOCURRENCIES = 'predefined/cryptocurrencies',
  PREDEFINED_CRYPTOCURRENCY_EXCHANGES = 'predefined/cryptocurrency-exchanges',
  PREDEFINED_CURRENCIES = 'predefined/currencies',
  PREDEFINED_FINANCIALINSTITUTIONS = 'predefined/financial-institutions',
  PREDEFINED_FINANCIALINSTITUTIONS_BANKINGASSETS = 'predefined/financial-institutions/banking-assets',
  PREDEFINED_JURISDICTIONS = 'predefined/jurisdictions',
  PREDEFINED_HOMEINSURANCEPROVIDERS = 'predefined/home-insurance-providers',
  PREDEFINED_LIFEINSURANCEPROVIDERS = 'predefined/life-insurance-providers',
  PREDEFINED_PENSIONPLANPROVIDERS = 'predefined/pension-plan-providers',
  PREDEFINED_PROFESSIONS = 'predefined/professions',
  PREDEFINED_PROFESSIONS_ESTATEPROFESSIONALPROFESSIONS = 'predefined/professions/estate-professional-professions',
  PREDEFINED_VEHICLEMAKES = 'predefined/vehicle-makes',
  PREDEFINED_VEHICLEMODELS = 'predefined/vehicle-models',
  PROBATECOMMISSIONMEETINGS = 'probate-commission-meetings',
  PROBATEFORMS_NOTIFY_START = 'probate-forms/notify-start',
  PROBATEREFEREES = 'probate-referees',
  PROTECTIONMANDATES = 'protection-mandates',
  PROTECTIONMANDATARYVERIFIERS = 'protection-mandatary-verifiers',
  PROTECTIONMANDATE_DOCUMENT = 'protection-mandate/document',
  PROTECTIONMANDATE_FINALIZEANDSENDTOPLANNER = 'protection-mandate/finalize-and-send-to-planner',
  PROTECTIONMANDATE_RESET = 'protection-mandate/reset',
  PROTECTIONMANDATE_SENDTOPARTNER = 'protection-mandate/send-to-partner',
  PROTECTIONMANDATE_UNSENDTOPARTNER = 'protection-mandate/un-send-to-partner',
  PROTECTIONMANDATE_GENERATEFINALPROTECTIONMANDATEDOCUMENT = 'protection-mandate/generate-final-protection-mandate-document',
  REFERRALS = 'referrals',
  REFERRALS_FORM = 'referrals/form',
  REFERRAL_ARCHIVE = 'referrals/archive',
  REFERRAL_UNARCHIVE = 'referrals/unarchive',
  REFERRAL_ARCHIVED = 'referrals/archived',
  REFERRAL_PENDING = 'referrals/pending',
  REFERRALS_PREFILLING_SAVE_INVENTORY_ENTITY = 'referrals/prefilling/save-inventory-entity',
  REFERRALS_PREFILLING_DELETE_INVENTORY_ENTITY = 'referrals/prefilling/delete-inventory-entity',
  REFERRALS_PREFILLING_INVENTORY_ASSETS = 'referrals/prefilling/inventory/assets',
  REFERRALS_PREFILLING_INVENTORY_LIABILITIES = 'referrals/prefilling/inventory/liabilities',
  REFERRAL_RESEND = 'referrals/resend',
  REFERRAL_DELETE = 'referrals/delete',
  REFERRAL_INVITECLIENT = 'referrals/invite-client',
  REFERRAL_MOVE_TO_TEAM = 'referrals/move-to-team',
  REFERRAL_SAVESELFREFERRAL = 'referrals/save-self-referral',
  REFERRAL_STARTSELFREFERRAL = 'referrals/start-self-referral',
  REFERRAL_PARTNER = 'referrals/partner',
  REMINDERS_SETUPLOADDOCUMENTS = 'reminders/set-upload-documents',
  REVENUEAGENCYREQUESTS = 'revenue-agency-requests',
  REVIEW_INIT = 'review/init',
  SEND_SLACK_NOTIFICATION = 'notifications/send-slack-notification',
  SETTINGS = 'settings',
  STRIPE_COUPONS = 'stripe/coupons',
  SPOTLIGHT = 'spotlight',
  STOCKS = 'stocks',
  TAXCALCULATION_CALCULATE = 'tax-calculation/calculate',
  TAXCALCULATION_PROBATETAX_SENDREPORTLINK = 'tax-calculation/probate-tax/send-report-link',
  TAXCALCULATION_PROBATETAX_REPORTDATA = 'tax-calculation/probate-tax/report-data',
  TAXES = 'taxes',
  TAXES_DETAILS = 'taxes/details',
  TEAMS = 'teams',
  TEAMS_ACCEPTINVITE = 'teams/accept-invite',
  TEAMS_CLEAR_ESTATE_COMPANY_ESTATE_PROFESSIONAL_TYPE = 'teams/clear-estate-company-estate-professional-type',
  TEAMS_CREATE = 'teams/create',
  TEAMS_UPDATEROLE = 'teams/update-role',
  TEAMS_INVITEMEMBERS = 'teams/invite-members',
  TEAMS_SET_CURRENT_TEAM = 'teams/set-current-team',
  TEAMS_CHECKOUT_SET_CURRENT_TEAM = 'teams/checkout/set-current-team',
  TEAMS_DELETE = 'teams/delete',
  TEAMS_DELETEMEMBER = 'teams/delete-member',
  TEAM_INVITES = 'team-invites',
  TOKEN = 'token',
  UI_LAUNCHCARDS_STATUS = 'ui/launch-cards/status',
  UI_NAV = 'ui/nav',
  USERS = 'users',
  USERS_ADDBENEFICIARY = 'users/add-beneficiary',
  USERS_ESTATES = 'users/estates',
  USERS_ESTATEADMIN = 'users/estate-admin',
  USERS_CANBEGUARDIAN = 'users/can-be-guardian',
  USERS_CONTACTPROFESSIONALS = 'users/contact-professionals',
  USERS_ESTATESMEMBERS = 'users/estate-members',
  USERS_ESTATESTAKEHOLDERS = 'users/estate-stakeholders',
  USERS_SAVE_CONTACT = 'users/save-contact',
  USERS_USERFLOWS = 'users/user-flows',
  USERS_USERTOURS = 'users/user-tours',
  USERS_ONBOARDING_FINANCIALADVISOR = 'users/onboarding/financial-advisor',
  USERS_FINANCIALADVISORPARTNERS = 'users/financial-advisor-partners',
  USERS_GUARDIANS = 'users/guardians',
  USERS_GUIDES = 'users/guides',
  USERS_INVITE = 'users/invite',
  USERS_INBOX_DIRECT = 'users/inbox/direct',
  USERS_INBOX_CASEMANAGER = 'users/inbox/case-manager',
  USERS_INVITE_PROFESSIONAL = 'users/invite/professional',
  USERS_INVITE_ESTATEMEMBER = 'users/invite/estate-member',
  USERS_MENTIONABLE = 'users/mentionable',
  USERS_ADDNEXTOFKIN = 'users/add-next-of-kin',
  USERS_REMOVENEXTOFKIN = 'users/remove-next-of-kin',
  USERS_PRIMARYEXECUTOR = 'users/primary-executor',
  USERS_PROFESSIONALSSAMETEAM = 'users/professionals-same-team',
  USERS_PROFESSIONALSSAMECOMPANY = 'users/professionals-same-company',
  USERS_PROFILEIMAGE = 'users/profile-image',
  USERS_SPOUSE = 'users/spouse',
  USERS_DELETE_ACCOUNT = 'users/delete-account',
  USERS_EMAIL_CHANGE = 'users/email-change',
  USERS_EMAIL_CHANGE_VERIFY = 'users/email-change/verify',
  USERS_EMAIL_CHANGE_RESEND = 'users/email-change/resend',
  USERS_EMAIL_CHANGE_GOOGLE_REAUTH = 'users/email-change/google-reauth',
  VAULTDISTRIBUTIONSETTINGS = 'vault-distribution-settings',
  VAULTDISTRIBUTIONSETTINGS_RECIPIENTTYPEOPTIONS = 'vault-distribution-settings/recipient-type-options',
  VAULTEXTRAINFORMATION = 'vault-extra-information',
  WILLS = 'wills',
  WILLS_BOOKREVIEWMEETING = 'wills/book-review-meeting',
  WILLS_NOTIFYOUTSIDECOUNSELONADDITIONALNEEDS = 'wills/notify-outside-counsel-on-additional-needs',
  WILLS_UNSENDNOTIFYOUTSIDECOUNSELONADDITIONALNEEDS = 'wills/un-send-notify-outside-counsel-on-additional-needs',
  WILLS_PRODUCENEWWILL = 'wills/produce-new-will',
  WILLS_REGENERATEWILLDOCX = 'wills/regenerate-will-docx',
  WILLS_SENDFINALWILLTOPLANNER = 'wills/send-final-will-to-planner',
  WILLS_WILLDOCUMENT = 'wills/will-document',
  WILLS_WILLCOVERPAGE = 'wills/will-cover-page',
  WILLS_WILLDOCX = 'wills/will-docx',
  WILLS_COMBINETOFINAL = 'wills/combine-to-final',
  WILLS_WILLCOVERSHEET = 'wills/will-cover-sheet',
  WILLS_GENERATEFINALWILL = 'wills/generate-final-will',
  WILLS_GENERATEFINALSECONDARYWILL = 'wills/generate-final-secondary-will',
  WILLS_WILLDOCUMENT_CLEARWILL = 'wills/will-document/clear-will',
  WILLS_WILLSNOTICESEARCH = 'wills/wills-notice-search',
  WORKFLOWS = 'workflows',
  WORKFLOWS_AVAILABLE_JURISDICTIONS = 'workflows/available-jurisdictions',
  WORKFLOWS_AVAILABLE_ESTATE_STATUSES = 'workflows/available-estate-statuses',
  WORKFLOWS_AVAILABLE_GUIDANCE_STEPS = 'workflows/available-guidance-steps',
  WORKFLOWS_SAVE = 'workflows/save',
  AUTH_ENVVALUES = 'auth/env-values',
  AUTH_PERMISSIONS = 'auth/permissions',
  ESTATES_OPS_RECENT = 'estates/ops/recent',
  ESTATES_OPS_SETTLEMENT = 'estates/ops/settlement',
  ESTATES_OPS_PLANNING = 'estates/ops/planning',
  ESTATES_RESTORE_ESTATE = 'estates/restore-estate',
  HUBSPOT_MEETINGNOTES = 'hubspot/meeting-notes',
  HUBSPOT_PRODUCTS = 'hubspot/products',
  HUBSPOT_DEALS = 'hubspot/deals',
  HUBSPOT_TRACKAFTERCAREACTIVITTY = 'hubspot/track-aftercare-activity',
  NOTIFICATIONS = 'notifications',
  NOTIFICATIONS_CLEAR = 'notifications/clear',
  NOTIFICATIONS_UNCLEAR = 'notifications/unclear',
  NOTIFICATIONS_FILTERCOUNTS = 'notifications/filter-counts',
  NOTIFICATIONS_SETTINGS = 'notifications/settings',
  NOTIFICATIONS_ESTATES = 'notifications/estates',
  STATUSENTRIES = 'status-entries',
  TEAMS_ASSIGNABLETOESTATETASK = 'teams/assignable-to-estate-task',
  TEAMS_WORKLOAD = 'teams/workload-team',
  TYPEFORM_FORMS = 'typeform/forms',
  TIMEENTRIES = 'time-entries',
  TOOLS_DIAGNOSTIC_FORMS = 'tools/diagnostic/forms',
  TOOLS_DIAGNOSTIC_RESULTS = 'tools/diagnostic/results',
  TOOLS_DIAGNOSTIC_SENDFORMLINK = 'tools/diagnostic/send-form-link',
  USERS_ASSIGNABLETOESTATE = 'users/assignable-to-estate',
  USERS_ASSIGNABLETOESTATEBYPROFESSION = 'users/assignable-to-estate-by-profession',
  USERS_ASSIGNTOESTATE = 'users/assign-to-estate',
  USERS_CHECK_IN_OTHER_ESTATE = 'users/check-in-other-estate',
  USERS_TIMEENTRIES = 'users/time-entries',
  USERS_GETAVAILABILITY = 'users/get-availability',
  USERS_SETAVAILABILITY = 'users/set-availability',
  USERS_PROFESSIONALS_ADMIN = 'users/professionals/admin',
  PERMISSION_SETS = 'permission-sets',
  PERMISSION_SETS_PREVIEW = 'permission-sets/preview',
  PERMISSION_SETS_FORM = 'permission-sets/form',
  PERMISSION_SETS_DUPLICATE = 'permission-sets/duplicate',
  FEATURE_FLAGS = 'feature-flags'
}

export const PublicRoutes: Route[] = [Route.AUTH_LOGIN, Route.AUTH_SESSION];

export enum BroadcastChannel {
  PUBLIC = 'public.broadcast'
}

export enum HttpStatus {
  CONTINUE = 100,
  SWITCHING_PROTOCOLS = 101,
  PROCESSING = 102,
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  NON_AUTHORITATIVE_INFORMATION = 203,
  NO_CONTENT = 204,
  RESET_CONTENT = 205,
  PARTIAL_CONTENT = 206,
  MULTI_STATUS = 207,
  MULTIPLE_CHOICES = 300,
  MOVED_PERMANENTLY = 301,
  MOVED_TEMPORARILY = 302,
  SEE_OTHER = 303,
  NOT_MODIFIED = 304,
  USE_PROXY = 305,
  TEMPORARY_REDIRECT = 307,
  PERMANENT_REDIRECT = 308,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  PAYMENT_REQUIRED = 402,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,
  NOT_ACCEPTABLE = 406,
  PROXY_AUTHENTICATION_REQUIRED = 407,
  REQUEST_TIMEOUT = 408,
  CONFLICT = 409,
  GONE = 410,
  LENGTH_REQUIRED = 411,
  PRECONDITION_FAILED = 412,
  REQUEST_TOO_LONG = 413,
  REQUEST_URI_TOO_LONG = 414,
  UNSUPPORTED_MEDIA_TYPE = 415,
  REQUESTED_RANGE_NOT_SATISFIABLE = 416,
  EXPECTATION_FAILED = 417,
  IM_A_TEAPOT = 418,
  INSUFFICIENT_SPACE_ON_RESOURCE = 419,
  METHOD_FAILURE = 420,
  UNPROCESSABLE_ENTITY = 422,
  LOCKED = 423,
  FAILED_DEPENDENCY = 424,
  PRECONDITION_REQUIRED = 428,
  TOO_MANY_REQUESTS = 429,
  REQUEST_HEADER_FIELDS_TOO_LARGE = 431,
  UNAVAILABLE_FOR_LEGAL_REASONS = 451,
  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504,
  HTTP_VERSION_NOT_SUPPORTED = 505,
  INSUFFICIENT_STORAGE = 507,
  NETWORK_AUTHENTICATION_REQUIRED = 511
}
